import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const MapMatchReport = ({ report }) => {
	const [collapsed, setCollapsed] = useState(true);
	if (!report) {
		return null;
	}
	const unmatchedPins = report.unmatchedPins || [];
	const unmatchedCodes = report.unmatchedCodes || [];
	const title = report.areaTypeSet
		? `Unmatched (${unmatchedPins.length} pins, ${unmatchedCodes.length} codes)`
		: 'Unmatched (area code not set)';
	return (
		<div className={classnames('mapLegend', 'mapMatchReport', { 'mapLegend--collapsed': collapsed })}>
			<button
				type="button"
				className="mapLegend-toggle"
				onClick={() => { setCollapsed(prev => !prev); }}
				aria-expanded={!collapsed}>
				<span className="mapLegend-title">{title}</span>
				<span
					className={classnames(
						'glyphicon',
						collapsed ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down'
					)}
					aria-hidden="true">
				</span>
			</button>
			{collapsed
				? null
				: (
					<div className="mapLegend-body mapMatchReport-body">
						{report.areaTypeSet
							? (
								<p className="mapMatchReport-summary">
									{report.matchedPinCount} of {report.uniquePinCount} pins match
									{report.areaTypeName ? ` ${report.areaTypeName}` : ''} descriptions
									({report.matchedCodeCount} of {report.codeCount} codes).
								</p>
							)
							: (
								<p className="mapMatchReport-summary">
									Choose an Area Activity Code Type to match pins to activity codes.
									Pins stay visible.
								</p>
							)}
						<p className="mapMatchReport-heading">Pins with no matching code</p>
						{unmatchedPins.length
							? (
								<ul>
									{unmatchedPins.map(name => <li key={name}>{name}</li>)}
								</ul>
							)
							: <p className="mapMatchReport-empty">None</p>}
						{report.areaTypeSet
							? (
								<React.Fragment>
									<p className="mapMatchReport-heading">Codes with no matching pin</p>
									{unmatchedCodes.length
										? (
											<ul>
												{unmatchedCodes.map(name => <li key={name}>{name}</li>)}
											</ul>
										)
										: <p className="mapMatchReport-empty">None</p>}
								</React.Fragment>
							)
							: null}
					</div>
				)}
		</div>
	);
};

MapMatchReport.propTypes = {
	report: PropTypes.shape({
		areaTypeSet: PropTypes.bool,
		areaTypeName: PropTypes.string,
		pinCount: PropTypes.number,
		uniquePinCount: PropTypes.number,
		codeCount: PropTypes.number,
		matchedPinCount: PropTypes.number,
		matchedCodeCount: PropTypes.number,
		unmatchedPins: PropTypes.arrayOf(PropTypes.string),
		unmatchedCodes: PropTypes.arrayOf(PropTypes.string)
	})
};

export default MapMatchReport;
